import { AnyAction } from 'redux'
import { AppDispatch, RootState } from '../../../store'
import {
  CloudMarketplace,
  Product,
  ProductDimension,
} from '../productsListing/reducer'
import { camelize, snakeize } from 'casing'
import { cloneDeep, get, isEmpty, isNil, toLower, toUpper } from 'lodash'
import emptyResaleAuthorization from '../../../mocks/emptyResaleAuthorization.json'
import emptyMicrosoftResaleAuthorization from '../../../mocks/emptyMicrosoftResaleAuthorization.json'
import {
  KeyValue,
  createOfferErrors,
  getUpdatedDimensions,
} from '../privateOffer/privateOfferCreation/actions'
import {
  AzureOfferPlan,
  Dimension,
  EulaType,
  OfferStakeholders,
  Price,
  PriceTypes,
  RecurrentPriceModeType,
} from '../privateOffer/reducer'
import { getFilteredInstallments } from '../privateOffer/privateOfferCreation/actions'
import {
  startLoading,
  stopLoading,
} from '../../../common/modules/loading/actions'
import { LoadingTypes } from '../../../common/modules/loading/reducer'
import { updateAppAlert } from '../../../common/modules/appAlert/actions'
import { getErrorMessages } from '../../../common/utils/error'
import { AxiosError, AxiosResponse } from 'axios'
import { defaultCrmType } from '../../../common/utils/constants'
import { Installments } from '../privateOffer/reducer'
import {
  cloneResaleAuthSuccess,
  deactivateResaleAuthSuccess,
  RequestFailureMessage,
  resaleAuthorizationCreationSuccess,
  resaleAuthorizationSaveSuccess,
} from '../../../common/utils/messagesContants'
import {
  getSingleResaleAuthorization,
  patchResellerData,
  postResaleAuthorization,
} from '../../api/markeplace'
import { errorLogger } from '../../../common/utils/errorLogger'
import { mapObjectPropertyEmptyToNull } from '../../../common/utils/mapObjectPropertyEmptyToNull'
import { ResaleAuthorizationWithErrors } from './reducer'
import {
  ContractDurationType,
  DiscountType,
  ResaleAuthorizationsResellerAgreements,
  ResellerAgreementStatus,
  ResellerInfo,
  Stakeholders,
} from '../../../admin/modules/resaleAuthorizations/reducer'
import { isNonEmptyNumber } from '../../../common/utils/validateMinMax'
import { UserProfile } from '../../../common/modules/userProfile/action'
import { getCurrentResaleAuthorization } from '../../../admin/modules/resaleAuthorizations/actions'
import {
  cloneMicrosoftResaleAuthorization,
  getMicrosoftResaleAuthorization,
  patchMicrosoftResaleAuthorization,
  postMicrosoftResaleAuthorization,
} from '../../api/azure'
import { DateTime } from 'luxon'
import { convertProductPlanToOfferPlan } from '../../components/MicrosoftFormComponent/Plan/PlanRow/ContractSelection/ContractSelection'
import { UserState } from '../../../oppsync/modules/userList/reducer'
import { calculateBuyerPrice } from '../../../common/utils/getDiscountedPriceValue'
import { PlanType } from '@labrav/react-components'
import { PartnerType } from '../../../common/modules/partner/action'

export enum ResaleAuthorizationCreationActionTypes {
  SET_CREATE_RESALE_AUTHORIZATIONS_DATA = 'SET_CREATE_RESALE_AUTHORIZATIONS_DATA',
  ADD_ROWS_ON_RESALE_AUTHORIZATION = 'ADD_ROWS_ON_RESALE_AUTHORIZATION',
  DELETE_ROWS_ON_RESALE_AUTHORIZATION = 'DELETE_ROWS_ON_RESALE_AUTHORIZATION',
  UPDATE_VALUES_OF_ARRAY_ON_RESALE_AUTHORIZATION = 'UPDATE_VALUES_OF_ARRAY_ON_RESALE_AUTHORIZATION',
  UPDATE_RESALE_AUTHORIZATION_CREATION_ERRORS = 'UPDATE_RESALE_AUTHORIZATION_CREATION_ERRORS',
  SET_ERRORS_FOR_MULTIPLE_FIELDS = 'SET_ERRORS_FOR_MULTIPLE_FIELDS',
  CLEAR_RESALE_AUTHORIZATION_IN_CREATION = 'CLEAR_RESALE_AUTHORIZATION_IN_CREATION',
  UPDATE_RESALE_AUTHORIZATIONS = 'UPDATE_RESALE_AUTHORIZATIONS',
  UPDATE_DIMENSION_ON_RESALE_AUTHORIZATION = 'UPDATE_DIMENSION_ON_RESALE_AUTHORIZATION',
  UPDATE_PRICES_ON_RESALE_AUTHORIZATION_DIMENSIONS = 'UPDATE_PRICES_ON_RESALE_AUTHORIZATION_DIMENSIONS',
  ADD_DIMENSION_ROWS_ON_RESALE_AUTHORIZATIONS = 'ADD_DIMENSION_ROWS_ON_RESALE_AUTHORIZATIONS',
  UPDTE_RESALE_AUTHORIZATION_HAS_BEEN_SENT = 'UPDTE_RESALE_AUTHORIZATION_HAS_BEEN_SENT',
  UPDATE_NUMBER_OF_TIMES_SAVED_ON_RESALE_AUTHORIZATION = 'UPDATE_NUMBER_OF_TIMES_SAVED_ON_RESALE_AUTHORIZATION',
  ADD_FILES_ON_RESALE_AUTHORIZATION = 'ADD_FILES_ON_RESALE_AUTHORIZATION',
}
export const getPricesArray = (dimensions: Dimension[]) => {
  // Prices Durations which are selected for one dimensions will be selected for all the dimensions, so taking only first one and getting non null fields
  let pricesArray: string[] = []
  const dimension = dimensions.find(
    dimension => !dimension.isAdditionalUsageAllowed
  )
  if (dimension?.prices) {
    const prices = dimension.prices as PriceTypes
    pricesArray = (Object.keys(prices) as [keyof PriceTypes]).filter(
      (price: keyof PriceTypes) => prices[price] !== null
    )
  }
  return pricesArray
}
export const arrayFieldsForValidations = [
  'agreementRecipients',
  'metaData',
  'installmentInfo',
  'dimensions',
]

const validateFields = [
  'companyName',
  'agreementName',
  'agreementDescription',
  'agreementRecipients',
  'metaData',
  'emailCustomMessage',
  'buyerAwsAccountId',
  'percentageDiscount',
  'installmentInfo',
  'dimensions',
  'resellersInfo',
  'discountType',
  'contractDurationType',
  'contractDurationInMonthsForEndCustomer',
  'agreementExpirationDate',
]

const getInitialResaleAuthorizationData = ({
  cloud,
  product,
  crmOpportunityId,
  userProfile,
  getState,
  labraNewUiRevamp,
}: {
  crmOpportunityId?: string
  cloud?: CloudMarketplace
  product: Product
  userProfile?: UserProfile
  getState: () => RootState
  labraNewUiRevamp?: boolean
}) => {
  switch (cloud) {
    case 'AWS': {
      const planType = product?.productType
      const { offerRecipients } =
        getState().privateOffersInCreation.currentPrivateOfferInCreation[
          product?.productId
        ] || []
      const { email, firstName, lastName, givenName, familyName } =
        getState().userProfile.userProfile
      const initialOfferRecipients = labraNewUiRevamp
        ? (offerRecipients && offerRecipients.length) > 0
          ? offerRecipients
          : [{ email: '', title: '', firstName: '', lastName: '' }]
        : []

      const updatedDimensions = getUpdatedDimensions(
        product?.productDimensions || [],
        planType,
        true
      )
      return camelize({
        ...emptyResaleAuthorization,
        crm_opportunity_id: crmOpportunityId ?? null,
        email_custom_message: product?.emailCustomMessage || '',
        dimensions: [...updatedDimensions],
        cloudProductName: product?.productName,
        agreementRecipients: initialOfferRecipients,
        resellers_info: labraNewUiRevamp
          ? []
          : emptyResaleAuthorization.resellers_info,
        ...(labraNewUiRevamp ? { meta_data: [{ key: '', value: '' }] } : {}),
        ...(labraNewUiRevamp &&
        product.productType !== PlanType.SAAS_SUBSCRIPTION
          ? {
              installmentInfo: [
                { paymentDate: '', amount: null, currency: 'USD' },
              ],
            }
          : {}),
        endCustomerEulaType: EulaType.PUBLIC,
        // resellerLicenseAgreementType: EulaType.CUSTOM,
        ...(labraNewUiRevamp
          ? {
              agreementStakeholders: crmOpportunityId
                ? []
                : email
                  ? [
                      {
                        email: email,
                        name: firstName,
                      },
                    ]
                  : [],
              customOfferStakeholders: [],
            }
          : {}),
      })
    }
    case 'AZURE': {
      return {
        ...camelize(emptyMicrosoftResaleAuthorization),
        offerStakeholders: [
          {
            firstName: userProfile?.firstName || '',
            lastName: userProfile?.lastName || '',
            email: userProfile?.email || '',
          },
        ],
      }
    }
    case 'GCP': {
      return {}
    }
    case 'REDHAT': {
      return {}
    }
    default: {
      return {}
    }
  }
}

const getCustomMeteres = ({ plan }: { plan: Record<string, any> }) => {
  const customMeters = plan?.pricing?.custom_meters?.meters || {}

  const customMetersObject = Object.entries(customMeters).reduce(
    (acc, [meterKey, meterValue]) => {
      acc[meterKey] = camelize(meterValue)
      return acc
    },
    {} as Record<string, any>
  )

  return { meters: customMetersObject }
}

export const getAzureMappedPlans = ({
  plans,
  product,
  viewOnly = false,
  isBuyerPrice = false,
}: {
  plans: Record<string, any>[]
  product: Product
  viewOnly?: boolean
  isBuyerPrice?: boolean
}) => {
  return plans?.map(item => {
    const productPlan = product?.plans?.find(
      planItem => planItem?.planId === item?.labra_plan_id
    )

    const offerPlan = convertProductPlanToOfferPlan(productPlan)
    const camelizedItem = camelize(item)
    const recurrentPrice = camelizedItem?.pricing?.recurrentPrice

    const isFlexiblePayment =
      recurrentPrice?.prices?.[0]?.paymentOption?.type === 'flexible' &&
      !viewOnly

    const originalPricingPrices =
      offerPlan?.originalPricing?.recurrentPrice?.prices?.filter(
        originalPrice =>
          originalPrice?.billingTerm?.type ===
            recurrentPrice?.prices?.[0]?.billingTerm?.type &&
          originalPrice?.billingTerm?.value ===
            recurrentPrice?.prices?.[0]?.billingTerm?.value
      ) || []

    const updatedRecurrentPrice =
      isFlexiblePayment && originalPricingPrices.length > 0
        ? {
            ...recurrentPrice,
            prices: [
              {
                ...recurrentPrice?.prices?.[0],
                paymentOption: {
                  ...originalPricingPrices[0]?.paymentOption,
                },
              },
            ],
          }
        : recurrentPrice
    return {
      ...camelizedItem,
      pricing: {
        recurrentPrice: cloneDeep(updatedRecurrentPrice),
        customMeters: getCustomMeteres({ plan: item }),
      },
      originalPricing: offerPlan?.originalPricing,
      ...(isBuyerPrice
        ? {
            buyerPrice: getBuyerPrice({
              updatedRecurrentPrice,
              markupPercentage: item?.markup_percentage || 0,
            }),
          }
        : {}),
    }
  })
}
const getBuyerPrice = ({
  updatedRecurrentPrice,
  markupPercentage,
}: {
  updatedRecurrentPrice: Record<string, any>
  markupPercentage: number
}) => {
  const isFlexiblePayment =
    updatedRecurrentPrice.prices[0]?.installments?.schedule?.length
  const priceValue = isFlexiblePayment
    ? updatedRecurrentPrice.prices[0].installments?.tcv
    : updatedRecurrentPrice.prices[0].pricePerPaymentInUsd

  return calculateBuyerPrice({
    wholesalePrice: priceValue || 0,
    percentage: markupPercentage || 0,
  })
}
const getEditResaleAuthorizationData = async ({
  cloud,
  product,
  partnerId,
  resaleAuthorizationId,
  crmOpportunityId,
  userList,
  getState,
  partnerType = PartnerType.User,
}: {
  crmOpportunityId?: string
  cloud?: CloudMarketplace
  product: Product
  partnerId: string
  resaleAuthorizationId: string
  userList: UserState[]
  getState: () => RootState
  partnerType?: PartnerType
}) => {
  try {
    switch (cloud) {
      case 'AWS': {
        const planType = product?.productType
        const users = getState()?.userList[partnerType].userList.users.map(
          ({ email }) => email
        )
        const { data } = await getSingleResaleAuthorization(
          partnerId,
          resaleAuthorizationId,
          crmOpportunityId
        )
        const { createdAt, products, ...agreementData } = camelize(data)
        agreementData.agreementDurationType = toUpper(
          agreementData.agreementDurationType
        )
        agreementData.resellerLicenseAgreementType = toUpper(
          agreementData.resellerLicenseAgreementType
        )
        const convertedDiscountType =
          planType === PlanType.SAAS_SUBSCRIPTION
            ? DiscountType.USAGE_PRICING
            : agreementData.discountType
        agreementData.discountType = toUpper(convertedDiscountType)
        const additionalUsageDimensions = getUpdatedDimensions(
          product?.productDimensions || [],
          planType,
          true
        )
        let contractDuration =
          agreementData?.contractDurationInMonthsForEndCustomer
        if (
          agreementData?.contractDurationTimeUnit === 'YEARS' &&
          agreementData?.contractDurationInMonthsForEndCustomer &&
          planType !== PlanType.SAAS_SUBSCRIPTION
        ) {
          const months = Number(
            agreementData.contractDurationInMonthsForEndCustomer
          )
          contractDuration = months / 12
        }
        const updatedDimensions =
          agreementData?.discountType === DiscountType.DISCOUNT
            ? additionalUsageDimensions
            : [...get(products, '[0].dimensions', [])]
        const stackHolderExisting =
          (agreementData.agreementStakeholders || [])?.filter((item: any) =>
            users.includes(item.email)
          ) || []
        const stackHolderCustom =
          (agreementData.agreementStakeholders || [])?.filter(
            (item: any) => !users.includes(item.email)
          ) || []
        return {
          ...agreementData,
          dimensions: updatedDimensions,
          contractDurationInMonthsForEndCustomer: contractDuration,
          agreementStakeholders: [...stackHolderExisting],
          customOfferStakeholders: [...stackHolderCustom],
        }
      }
      case 'AZURE': {
        const response = await getMicrosoftResaleAuthorization({
          partnerId,
          resaleAuthorizationId,
          crmOpportunityId,
        })

        const { plans, ...remainingResaleAuthorizationDetail } = response?.data

        const {
          resellerDetails,
          offerRecipients,
          links,
          cloud,
          offerStakeholders,
          eulaFiles,
          emailCustomMessage,
          metaData,
          offerEndBuyers,
          ...remainingResaleAuthorization
        } = camelize(remainingResaleAuthorizationDetail)

        const azurePricingType = plans?.length
          ? plans[0].discount_type
          : 'absolute'

        const users = userList.map(({ email }) => email)
        const existingStakeHolder =
          (offerStakeholders || [])?.filter((item: Stakeholders) =>
            users.includes(item.email)
          ) || []
        const stackHolderCustom =
          (offerStakeholders || [])?.filter(
            (item: Stakeholders) => !users.includes(item.email)
          ) || []

        return {
          ...camelize({
            ...remainingResaleAuthorization,
            acceptBy: remainingResaleAuthorization?.acceptBy || null,
            offerExpirationDate:
              remainingResaleAuthorization?.offerExpirationDate || null,
            offerStartDate:
              remainingResaleAuthorization?.offerStartDate || null,
            eulaFiles: eulaFiles || [],
            emailCustomMessage: emailCustomMessage || '',
            resellerDetails: resellerDetails || [
              {
                id: '',
                partnerName: '',
              },
            ],
            offerRecipients: offerRecipients?.length
              ? offerRecipients
              : [
                  {
                    first_name: '',
                    last_name: '',
                    title: null,
                    email: '',
                  },
                ],
            offerEndBuyers: (offerEndBuyers || [])?.length
              ? offerEndBuyers
              : [
                  {
                    first_name: '',
                    last_name: '',
                    title: null,
                    email: '',
                  },
                ],
            metaData: (metaData || [])?.length
              ? metaData
              : [
                  {
                    key: '',
                    value: '',
                  },
                ],
            azurePricingType,
            offerStakeholders: [...existingStakeHolder],
            customOfferStakeholders: [...stackHolderCustom],
          }),
          plans: plans?.length
            ? getAzureMappedPlans({ plans, product })
            : [
                {
                  displayName: '',
                  planId: '',
                  offerPricingType: 'saasNewCustomizedPlans',
                  description: '',
                  labraPlanId: '',
                  discountPercentage: null,
                  pricing: {
                    recurrentPrice: {
                      recurrentPriceMode: '',
                      priceInputOption: 'usd',
                      prices: [],
                    },
                  },
                },
              ],
        }
      }
      case 'GCP': {
        return {}
      }
      case 'REDHAT': {
        return {}
      }
      default: {
        return {}
      }
    }
  } catch (error) {
    return {}
  }
}

export const getCurrentResaleAuthorizationInCreation =
  ({
    partnerId,
    productId,
    resaleAuthorizationId,
    crmOpportunityId,
    cloud,
    labraNewUiRevamp,
  }: {
    partnerId: string
    productId: string
    resaleAuthorizationId: string
    crmOpportunityId?: string
    cloud?: CloudMarketplace
    labraNewUiRevamp?: boolean
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const cloudMarketplace = cloud || 'AWS'

    const product =
      getState().productsListing[cloudMarketplace].products.rows.find(
        product => product.productId === productId
      ) || ({} as Product)

    const userProfile = getState().userProfile.userProfile

    let offerData = {}
    let errors = {}
    if (isEmpty(resaleAuthorizationId)) {
      offerData = getInitialResaleAuthorizationData({
        product,
        cloud: cloudMarketplace,
        crmOpportunityId,
        userProfile,
        getState,
        labraNewUiRevamp,
      })
    } else {
      const { userList } = getState().userList.user
      offerData = await getEditResaleAuthorizationData({
        partnerId,
        product,
        resaleAuthorizationId,
        cloud: cloudMarketplace,
        crmOpportunityId,
        userList: userList.users,
        getState,
      })
    }

    //this block should be remove when rewamp the AWS resale auth
    if (cloudMarketplace === 'AWS') {
      const pricesArray: string[] = getPricesArray(
        product?.productDimensions as Dimension[]
      )

      offerData = {
        ...camelize(offerData),
        pricesArray,
        ...(labraNewUiRevamp
          ? {
              contract_duration_time_unit: 'MONTHS',
            }
          : {}),
      }
      const { resellersInfo, ...errorsData } = createOfferErrors(
        offerData,
        arrayFieldsForValidations,
        true
      )
      errors = errorsData
    }
    dispatch(
      setResaleAuthorizationInCreation({
        productId,
        data:
          cloudMarketplace === 'AWS'
            ? { ...camelize(offerData) }
            : { ...offerData },
        errors: errors || {},
        noOfTimesSaved: isEmpty(resaleAuthorizationId) ? 0 : 2,
      })
    )
  }

export type setResaleAuthorizationInCreationProps = {
  productId: string
  data: Record<string, unknown>
  errors: Record<string, unknown>
  noOfTimesSaved: number
}
export const setResaleAuthorizationInCreation = ({
  productId,
  data,
  errors,
  noOfTimesSaved = 0,
}: setResaleAuthorizationInCreationProps) =>
  ({
    type: ResaleAuthorizationCreationActionTypes.SET_CREATE_RESALE_AUTHORIZATIONS_DATA,
    payload: {
      productId,
      resaleAuthorizationData: data,
      errors,
      noOfTimesSaved,
    },
  }) as unknown as AnyAction

export const setErrorsOnResaleAuthorizationCreation = (
  key: string,
  productId: string,
  field?: string,
  index?: number,
  standardDimensions?: ProductDimension[]
) => ({
  type: ResaleAuthorizationCreationActionTypes.UPDATE_RESALE_AUTHORIZATION_CREATION_ERRORS,
  payload: { key, productId, field, index, standardDimensions },
})

export const setValuesInArrayOfResaleAuthorizations = (
  key: string,
  index: number,
  resaleAuthorizationData: KeyValue,
  productId: string
) => ({
  type: ResaleAuthorizationCreationActionTypes.UPDATE_VALUES_OF_ARRAY_ON_RESALE_AUTHORIZATION,
  payload: { key, resaleAuthorizationData, index, productId },
})

export const clearResaleAuthorizationInCreation = (productId: string) => ({
  type: ResaleAuthorizationCreationActionTypes.CLEAR_RESALE_AUTHORIZATION_IN_CREATION,
  payload: productId,
})

export const addRowsOnResaleAuthorization = (
  key: string,
  productId: string,
  type = 'standard'
) => ({
  type: ResaleAuthorizationCreationActionTypes.ADD_ROWS_ON_RESALE_AUTHORIZATION,
  payload: { key, productId, type },
})
export const deleteRowsOnResaleAuthorization =
  (key: string, index: number, productId: string) =>
  async (dispatch: AppDispatch) => {
    await dispatch(deleteRows(key, index, productId))
    if (validateFields.includes(key)) {
      await dispatch(setErrorsOnResaleAuthorizationCreation(key, productId))
    }
  }
export const deleteRows = (key: string, index: number, productId: string) => ({
  type: ResaleAuthorizationCreationActionTypes.DELETE_ROWS_ON_RESALE_AUTHORIZATION,
  payload: { key, index, productId },
})

export const updatevaluesInArrayOfResaleAuthorizations =
  (
    key: string,
    index: number,
    resaleAuthorizationData: KeyValue,
    productId: string
  ) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    const state = getState()
    const cloudType = state.productListingFilters.cloudMarketplace
    const standardDimensions = state.productsListing[
      cloudType
    ].products.rows.filter(val => val.productId === productId)[0]
      .productDimensions
    await dispatch(
      setValuesInArrayOfResaleAuthorizations(
        key,
        index,
        resaleAuthorizationData,
        productId
      ) as unknown as AnyAction
    )
    if (validateFields.includes(key)) {
      await dispatch(
        setErrorsOnResaleAuthorizationCreation(
          key,
          productId,
          resaleAuthorizationData.key,
          index,
          standardDimensions
        ) as unknown as AnyAction
      )
    }
  }
export const updateResaleAuthorizationInCreation =
  (data: KeyValue, productId: string) => async (dispatch: AppDispatch) => {
    await dispatch(setResaleAuthorizationsData(data, productId))
    if (validateFields.includes(data.key)) {
      await dispatch(
        setErrorsOnResaleAuthorizationCreation(data.key as string, productId)
      )
    }
  }

export const setResaleAuthorizationsData = (
  data: KeyValue,
  productId: string
) => ({
  type: ResaleAuthorizationCreationActionTypes.UPDATE_RESALE_AUTHORIZATIONS,
  payload: { resaleAuthorizationData: data, productId },
})

export const updateDimensionOnResale = (
  index: number,
  productId: string,
  dimension: Dimension
) => ({
  type: ResaleAuthorizationCreationActionTypes.UPDATE_DIMENSION_ON_RESALE_AUTHORIZATION,
  payload: { productId, dimension, index },
})

export const updatePricesOnResaleDimensions =
  (productId: string, index: number, priceData: KeyValue) =>
  async (dispatch: AppDispatch) => {
    await dispatch(setPricesOnResale(productId, index, priceData))
    await dispatch(
      setErrorsOnResaleAuthorizationCreation(
        'dimensions',
        productId,
        priceData.key,
        index
      ) as unknown as AnyAction
    )
  }

export const setPricesOnResale = (
  productId: string,
  index: number,
  priceData: KeyValue
) => ({
  type: ResaleAuthorizationCreationActionTypes.UPDATE_PRICES_ON_RESALE_AUTHORIZATION_DIMENSIONS,
  payload: { productId, index, priceData },
})
export const updateHasBeenSent = (hasBeenSent: boolean, productId: string) => ({
  type: ResaleAuthorizationCreationActionTypes.UPDTE_RESALE_AUTHORIZATION_HAS_BEEN_SENT,
  payload: { hasBeenSent, productId },
})

export const updateNoOfTimesSaved = (productId: string) => ({
  type: ResaleAuthorizationCreationActionTypes.UPDATE_NUMBER_OF_TIMES_SAVED_ON_RESALE_AUTHORIZATION,
  payload: productId,
})

const returnNecessaryFieldResaleAuthorization = (
  resaleAuthorizationState: ResaleAuthorizationWithErrors
) => {
  const {
    errors,
    dimensions,
    pricesArray,
    hasBeenSent,
    noOfTimesSaved,
    resellerName,
    ...remainingResaleFields
  } = resaleAuthorizationState
  return remainingResaleFields
}

interface getDiscountedPriceProps {
  price: number | string | null
  percentageDiscount?: number
}

export const getDiscountedPrice = ({
  price,
  percentageDiscount,
}: getDiscountedPriceProps) => {
  if (isNil(price)) return null
  if (!percentageDiscount) return Number(price)
  return parseFloat(
    (
      Number(price) -
      (Number(price) * Number(percentageDiscount)) / 100
    ).toFixed(3)
  )
}

interface getPricesOrPriceProps {
  price?: Price
  prices?: Price
  quantity?: number | string
  isAdditional: boolean
  resaleAuthorizationState: ResaleAuthorizationWithErrors
  productType?: PlanType
}

export const getResalePriceKeySnakeizConversion: (key: string) => string = (
  key: string
) => {
  switch (key) {
    case 'price1m':
      return 'price_1m'
    case 'price12m':
      return 'price_12m'
    case 'price24m':
      return 'price_24m'
    case 'price36m':
      return 'price_36m'
    case 'additionalUsagePrice':
      return 'additional_usage_price'
    case 'subscriptionPrice':
      return 'subscription_price'
    default:
      return ''
  }
}

export const getResalePriceKeyCamelizeConversion: (key: string) => string = (
  key: string
) => {
  switch (key) {
    case 'price_1m':
      return 'price1m'
    case 'price_12m':
      return 'price12m'
    case 'price_24m':
      return 'price24m'
    case 'price_36m':
      return 'price36m'
    case 'additional_usage_price':
      return 'additionalUsagePrice'
    case 'subscription_price':
      return 'subscriptionPrice'
    default:
      return ''
  }
}

export const getPricesOrPriceOrQuantity = ({
  price,
  prices,
  quantity,
  isAdditional,
  resaleAuthorizationState,
}: getPricesOrPriceProps) => {
  const { contractDurationType, percentageDiscount, discountType } =
    resaleAuthorizationState
  const nullPriceObject = {
    price_1m: null,
    price_12m: null,
    price_24m: null,
    price_36m: null,
    additional_usage_price: null,
    subscription_price: null,
  }

  if (isAdditional && prices)
    return {
      prices: {
        ...nullPriceObject,
        additional_usage_price: getDiscountedPrice({
          percentageDiscount,
          price: (prices as PriceTypes)?.additionalUsagePrice,
        }),
      },
    }

  if (discountType === DiscountType.FLEXIBLE_PAYMENT_TERMS) {
    return { prices: nullPriceObject, quantity }
  } else {
    if (contractDurationType === ContractDurationType.CUSTOM) {
      return {
        prices: nullPriceObject,
        price,
      }
    } else {
      if (!prices) return {}
      const returnPrices = nullPriceObject as Record<string, number | null>
      for (const key in prices as PriceTypes) {
        if (Object.prototype.hasOwnProperty.call(prices, key)) {
          returnPrices[getResalePriceKeySnakeizConversion(key)] =
            getDiscountedPrice({ percentageDiscount, price: get(prices, key) })
        }
      }
      return {
        prices: returnPrices,
      }
    }
  }
}
export const getResalePricesOrPriceOrQuantity = ({
  price,
  prices,
  quantity,
  isAdditional,
  resaleAuthorizationState,
  productType,
}: getPricesOrPriceProps) => {
  const { contractDurationType, percentageDiscount, discountType } =
    resaleAuthorizationState
  const nullPriceObject = {
    price_1m: null,
    price_12m: null,
    price_24m: null,
    price_36m: null,
    additional_usage_price: null,
    subscription_price: null,
  }

  if (isAdditional && prices && productType !== PlanType.SAAS_SUBSCRIPTION)
    return {
      prices: {
        ...nullPriceObject,
        additional_usage_price: getDiscountedPrice({
          percentageDiscount,
          price: (prices as PriceTypes)?.additionalUsagePrice,
        }),
      },
    }
  if (productType === PlanType.SAAS_SUBSCRIPTION) {
    return {
      prices: {
        ...nullPriceObject,
        subscription_price: getDiscountedPrice({
          percentageDiscount,
          price: (prices as PriceTypes)?.subscriptionPrice,
        }),
      },
    }
  }

  if (discountType === DiscountType.FLEXIBLE_PAYMENT_TERMS) {
    return { prices: nullPriceObject, quantity }
  } else {
    // if (contractDurationType === ContractDurationType.CUSTOM) {
    return {
      prices: nullPriceObject,
      price,
    }
    //   }
    //   else {
    //     if (!prices) return {}
    //     const returnPrices = nullPriceObject as Record<string, number | null>
    //     for (const key in prices as PriceTypes) {
    //       if (Object.prototype.hasOwnProperty.call(prices, key)) {
    //         returnPrices[getResalePriceKeySnakeizConversion(key)] =
    //           getDiscountedPrice({ percentageDiscount, price: get(prices, key) })
    //       }
    //     }
    //     return {
    //       prices: returnPrices,
    //     }
    //   }
    // }
  }
}

const getDimensionsWithSpecificProperty = (
  productDimensions: ProductDimension[]
) => {
  return productDimensions.map(
    ({
      additionalUsageDescription,
      valueDataType,
      id,
      freeTrial,
      ...remainingDimension
    }) => ({ ...remainingDimension, dimensionId: id })
  )
}

export const getResellerProductDimensions = ({
  resaleAuthorizationState,
  product,
  selectedCurrency = 'USD',
}: {
  resaleAuthorizationState: ResaleAuthorizationWithErrors
  product: Product
  selectedCurrency?: string
}) => {
  const { dimensions } = resaleAuthorizationState

  const resaleDimensions =
    resaleAuthorizationState.discountType === DiscountType.DISCOUNT
      ? (getDimensionsWithSpecificProperty(
          product?.productDimensions || []
        ) as Dimension[])
      : dimensions
  if (!resaleDimensions || !resaleDimensions.length) return []

  const updatedDimensions = resaleDimensions
    ?.filter(d => !isEmpty(d.name))
    .map(({ price, prices, quantity, ...remainingDimension }) => ({
      ...snakeize(remainingDimension),
      currency: selectedCurrency,
      ...getPricesOrPriceOrQuantity({
        isAdditional:
          remainingDimension.isAdditionalUsageAllowed ||
          remainingDimension.type === 'additional_usage',
        price,
        prices,
        quantity,
        resaleAuthorizationState,
      }),
    }))

  return [
    {
      ...snakeize({
        awsProductId: resaleDimensions[0].awsProductId,
        productName: product.productName,
      }),
      dimensions: updatedDimensions,
    },
  ]
}

export const getUpdatedResellerProductDimensions = ({
  resaleAuthorizationState,
  product,
  selectedCurrency = 'USD',
}: {
  resaleAuthorizationState: ResaleAuthorizationWithErrors
  product: Product
  selectedCurrency?: string
}) => {
  const { dimensions } = resaleAuthorizationState

  const resaleDimensions =
    resaleAuthorizationState.discountType === DiscountType.DISCOUNT
      ? (getDimensionsWithSpecificProperty(
          product?.productDimensions || []
        ) as Dimension[])
      : dimensions
  if (!resaleDimensions || !resaleDimensions.length) return []
  const productType = product.productType
  const updatedDimensions = resaleDimensions
    ?.filter(d => !isEmpty(d.name))
    .map(({ price, prices, quantity, ...remainingDimension }) => ({
      ...snakeize(remainingDimension),
      currency: selectedCurrency,
      ...getResalePricesOrPriceOrQuantity({
        isAdditional:
          remainingDimension.isAdditionalUsageAllowed ||
          remainingDimension.type === 'additional_usage',
        price,
        prices,
        quantity,
        resaleAuthorizationState,
        productType,
      }),
    }))

  return [
    {
      ...snakeize({
        awsProductId: resaleDimensions[0].awsProductId,
        productName: product.productName,
      }),
      dimensions: updatedDimensions,
    },
  ]
}

const mapResellersInfo = ({
  resellersInfo,
}: {
  resellersInfo: ResellerInfo[]
}) => {
  const resellersInfoData = resellersInfo
    .filter(
      reseller =>
        reseller.labraPlatformResellerId || reseller.resellerAwsAccountId
    )
    .map(
      ({
        labraPlatformResellerId,
        resellerAwsAccountId,
        resellerCompanyName,
      }: ResellerInfo) => ({
        labraPlatformResellerId,
        resellerAwsAccountId,
        resellerCompanyName,
      })
    )
  return resellersInfoData.length
    ? { resellersInfo: resellersInfoData }
    : { resellersInfo: [] }
}
const processSendDataPayload = (
  resaleAuthorizationData: ResaleAuthorizationWithErrors,
  product: Product,
  userProfile: UserProfile,
  crmOpportunityId?: string,
  crmObjectLink?: string,
  saveAsDraft?: boolean,
  labraNewUiRevamp?: boolean
) => {
  const {
    discountType,
    agreementDurationType,
    resellerLicenseAgreementType,
    percentageDiscount,
    agreementExpirationDate,
    buyerAwsAccountId,
    awsAgreementId,
    resellersInfo,
    contractDurationType,
    contractDurationInMonthsForEndCustomer,
    companyName,
    agreementStakeholders,
    customOfferStakeholders,
    ...resaleAuthorization
  } = returnNecessaryFieldResaleAuthorization(resaleAuthorizationData)
  // const authorizationStakeholders = [
  //   {
  //     firstName: userProfile.firstName || '',
  //     lastName: userProfile.lastName || '',
  //     email: userProfile.email || '',
  //   },
  // ]

  let crmMetadata = {} as Record<string, unknown>
  if (crmOpportunityId && crmObjectLink) {
    crmMetadata = {
      crmType: defaultCrmType,
      crmObjectLink,
    }
  }
  const convertedDiscountType =
    product.productType === PlanType.SAAS_SUBSCRIPTION
      ? DiscountType.INDIVIDUAL_PRICING
      : discountType
  const updatedDiscountType = convertedDiscountType
    ? toLower(convertedDiscountType)
    : null
  const updatedAgreementDurationType = toLower(agreementDurationType)
  const UpdatedResellerLicenseAgreementType =
    toLower(resellerLicenseAgreementType) || null
  const updatedDraft = !!saveAsDraft
  const updatedPercentageDiscount = percentageDiscount
    ? percentageDiscount
    : null

  let contractDurationInMonths = contractDurationInMonthsForEndCustomer
  if (
    resaleAuthorization.contractDurationTimeUnit === 'YEARS' &&
    product.productType !== PlanType.SAAS_SUBSCRIPTION
  ) {
    contractDurationInMonths =
      (Number(contractDurationInMonthsForEndCustomer) || 0) * 12
  }
  // const updatedRecipients = agreementRecipients.filter(
  //   recipient => recipient.email
  // )
  // const updatedMetaData = metaData.filter(m => m.key)
  const updatedOfferStakeholders = [
    ...(agreementStakeholders as OfferStakeholders[]),
    ...(Array.isArray(customOfferStakeholders) ? customOfferStakeholders : []),
  ]

  const updatedResaleAuth = {
    ...resaleAuthorization,
    discountType: updatedDiscountType,
    agreementDurationType: updatedAgreementDurationType,
    resellerLicenseAgreementType: UpdatedResellerLicenseAgreementType,
    draft: updatedDraft,
    percentageDiscount: updatedPercentageDiscount,
    // agreementRecipients: updatedRecipients,
    // metaData: updatedMetaData,
    contractDurationInMonthsForEndCustomer: contractDurationInMonths,
    agreementStakeholders: updatedOfferStakeholders,
  }

  const updatedResaleAuthorization = {
    ...updatedResaleAuth,
    ...mapObjectPropertyEmptyToNull({
      agreementExpirationDate,
      buyerAwsAccountId,
      awsAgreementId,
      contractDurationType,
      companyName,
    }),
  }
  const { id, ...resaleAuthorizationToBeSentWithoutId } =
    updatedResaleAuthorization
  const dimensions = getUpdatedResellerProductDimensions({
    resaleAuthorizationState: resaleAuthorizationData,
    product,
    selectedCurrency: resaleAuthorizationData?.currency as string,
  })
  const installments = getFilteredInstallments(
    resaleAuthorizationToBeSentWithoutId.installmentInfo as unknown as Installments[]
  )
  const updatedInstallments = installments.map(inst => ({
    ...inst,
    currency: updatedResaleAuth.currency,
  }))
  const updatedEndCustomerEulaFiles =
    updatedResaleAuth?.endCustomerEulaType !== EulaType.CUSTOM
      ? []
      : updatedResaleAuth?.endCustomerEulaFiles
  const updatedResellerLicenseAgreementFiles =
    resellerLicenseAgreementType !== EulaType.CUSTOM
      ? []
      : updatedResaleAuth?.resellerLicenseAgreementFiles

  const resaleAuthData = {
    ...resaleAuthorizationToBeSentWithoutId,
    installmentInfo: updatedInstallments,
    endCustomerEulaFiles: updatedEndCustomerEulaFiles,
    resellerLicenseAgreementFiles: updatedResellerLicenseAgreementFiles,
  }

  const awsProductId = product?.productDimensions
    ? product.productDimensions[0].awsProductId || product.productId
    : product.productId

  const dataToBeSent = {
    ...snakeize({
      ...resaleAuthData,
      ...(crmOpportunityId ? { crmMetadata } : {}),
      ...mapResellersInfo({
        resellersInfo,
      }),
      awsProductId,
    }),
    products: dimensions,
  }
  return dataToBeSent
}

export const sendResaleAuthorization =
  ({
    partnerId,
    productId,
    saveAsDraft,
    crmOpportunityId,
    crmObjectLink,
    creatorData,
  }: {
    partnerId: string
    productId: string
    saveAsDraft?: boolean
    crmOpportunityId?: string
    crmObjectLink?: string
    creatorData?: {
      creatorEmail?: string
      creatorName?: string
    }
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(startLoading(LoadingTypes.GENERAL))
    try {
      //TODO LT-5308: When Azure enable for resale then we have to do dynamic
      const cloudMarketplace = 'AWS' //getState().productListingFilters.cloudMarketplace
      const product =
        getState().productsListing[cloudMarketplace].products?.rows.find(
          product => product.productId === productId
        ) || ({} as Product)

      const resaleAuthorizationState =
        getState().resaleAuthorizationsInCreation
          .currentResaleAuthorizationInCreation[productId]

      const {
        discountType,
        agreementDurationType,
        resellerLicenseAgreementType,
        percentageDiscount,
        agreementExpirationDate,
        buyerAwsAccountId,
        awsAgreementId,
        resellersInfo,
        contractDurationType,
        contractDurationInMonthsForEndCustomer,
        companyName,
        ...resaleAuthorization
      } = returnNecessaryFieldResaleAuthorization(resaleAuthorizationState)
      const {
        givenName: firstName,
        familyName: lastName,
        email,
      } = getState().userProfile.userProfile
      const hasCreatorData = !isEmpty(firstName) && !isEmpty(email)
      const creatorDataToBeSent = creatorData
        ? snakeize({ creatorData: creatorData })
        : hasCreatorData
          ? {
              creator_data: { creator_name: firstName, creator_email: email },
            }
          : {}
      const authorizationStakeholders = [
        {
          firstName: firstName || '',
          lastName: lastName || '',
          email: email || '',
        },
      ]
      const resaleAuthorizationToBeSent = { ...resaleAuthorization } as Record<
        string,
        unknown
      >
      let crmMetadata = {} as Record<string, unknown>
      if (crmOpportunityId && crmObjectLink) {
        crmMetadata = {
          crmType: defaultCrmType,
          crmObjectLink,
        }
      }
      resaleAuthorizationToBeSent.discountType = discountType
        ? toLower(discountType)
        : null

      resaleAuthorizationToBeSent.agreementDurationType = toLower(
        agreementDurationType
      )

      resaleAuthorizationToBeSent.resellerLicenseAgreementType =
        toLower(resellerLicenseAgreementType) || null

      resaleAuthorizationToBeSent.draft = !!saveAsDraft

      resaleAuthorizationToBeSent.percentageDiscount = percentageDiscount
        ? percentageDiscount
        : null

      resaleAuthorizationToBeSent.contractDurationInMonthsForEndCustomer =
        isNonEmptyNumber(contractDurationInMonthsForEndCustomer)
          ? contractDurationInMonthsForEndCustomer
          : null

      const updatedResaleAuthorization = {
        ...resaleAuthorizationToBeSent,
        ...mapObjectPropertyEmptyToNull({
          agreementExpirationDate,
          buyerAwsAccountId,
          awsAgreementId,
          contractDurationType,
          companyName,
        }),
      }
      const { id, ...resaleAuthorizationToBeSentWithoutId } =
        updatedResaleAuthorization

      resaleAuthorizationToBeSentWithoutId.installmentInfo =
        getFilteredInstallments(
          resaleAuthorizationToBeSentWithoutId.installmentInfo as unknown as Installments[]
        )
      resaleAuthorizationToBeSentWithoutId.agreementStakeholders = [
        ...authorizationStakeholders,
      ]
      resaleAuthorizationToBeSentWithoutId.endCustomerEulaFiles =
        resaleAuthorization?.endCustomerEulaType !== EulaType.CUSTOM
          ? []
          : resaleAuthorization?.endCustomerEulaFiles
      resaleAuthorizationToBeSentWithoutId.resellerLicenseAgreementFiles =
        resellerLicenseAgreementType !== EulaType.CUSTOM
          ? []
          : resaleAuthorization?.resellerLicenseAgreementFiles

      const awsProductId = product?.productDimensions
        ? product.productDimensions[0].awsProductId || product.productId
        : product.productId
      const dataToBeSent = {
        ...snakeize({
          ...resaleAuthorizationToBeSentWithoutId,
          ...(crmOpportunityId ? { crmMetadata } : {}),
          ...mapResellersInfo({
            resellersInfo,
          }),
          awsProductId,
        }),
        products: getResellerProductDimensions({
          resaleAuthorizationState,
          product,
        }),
      }
      if (isEmpty(id)) {
        const { data } = await postResaleAuthorization({
          partnerId,
          data: {
            ...dataToBeSent,
            ...creatorDataToBeSent,
          },
          saveAsDraft,
        })
        await dispatch(
          updateResaleAuthorizationInCreation(
            { key: 'id', value: camelize(data).labraAwsResellerAgreementId },
            productId
          ) as unknown as AnyAction
        )
      } else {
        await patchResellerData(
          partnerId,
          id as string,
          { ...dataToBeSent, ...creatorDataToBeSent },
          saveAsDraft
        )
      }
      if (!saveAsDraft) {
        await dispatch(updateHasBeenSent(true, productId))
      } else {
        await dispatch(updateNoOfTimesSaved(productId))
      }
      dispatch(
        updateAppAlert({
          message: saveAsDraft
            ? resaleAuthorizationSaveSuccess
            : resaleAuthorizationCreationSuccess,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(stopLoading(LoadingTypes.GENERAL))
    }
  }

export const addFilesOnResaleAuthorization = (
  productId: string,
  files: string[],
  key: 'endCustomerEulaFiles' | 'resellerLicenseAgreementFiles'
) => ({
  type: ResaleAuthorizationCreationActionTypes.ADD_FILES_ON_RESALE_AUTHORIZATION,
  payload: { productId, files, key },
})

export const cloneSaveData = (resaleAuthorization: Record<string, unknown>) => {
  const {
    id,
    agreementOrigin,
    cloudProductName,
    cloudProductUid,
    createdAt,
    crmAwsResellerAgreementObjectId,
    isvCloudAccountId,
    isvName,
    offersCreatedCount,
    agreementName,
    status,
    receivedResellerAgreementDimensions,
    productType,
    ...resaleAuthorizationValue
  } = resaleAuthorization

  return {
    ...resaleAuthorizationValue,
    agreementName: `Cloned ${agreementName}`,
  }
}

export const transformResaleAuthForSave = ({
  product,
  resaleAuthorizationState,
  crmOpportunityId,
  crmObjectLink,
  userProfile,
  cloud,
}: {
  userProfile: UserProfile
  product: Product
  resaleAuthorizationState: ResaleAuthorizationsResellerAgreements
  crmOpportunityId?: string
  crmObjectLink?: string
  cloud?: CloudMarketplace
}) => {
  switch (cloud) {
    case 'AWS': {
      const {
        discountType,
        agreementDurationType,
        resellerLicenseAgreementType,
        percentageDiscount,
        agreementExpirationDate,
        buyerAwsAccountId,
        awsAgreementId,
        resellersInfo,
        contractDurationType,
        contractDurationInMonthsForEndCustomer,
        companyName,
        installmentInfo,
        agreementApprovers,
        ...resaleAuthorization
      } = resaleAuthorizationState

      const { givenName: firstName, familyName: lastName, email } = userProfile
      const authorizationStakeholders = [
        {
          firstName: firstName || '',
          lastName: lastName || '',
          email: email || '',
        },
      ]
      const resaleAuthorizationToBeSent = { ...resaleAuthorization } as Record<
        string,
        unknown
      >
      let crmMetadata = {} as Record<string, unknown>
      if (crmOpportunityId && crmObjectLink) {
        crmMetadata = {
          crmType: defaultCrmType,
          crmObjectLink,
        }
      }

      const awsProductId = product?.productDimensions
        ? product.productDimensions[0].awsProductId || product.productId
        : product.productId
      return {
        ...snakeize({
          ...cloneSaveData(resaleAuthorizationToBeSent),
          draft: true,
          discountType: discountType ? toLower(discountType) : null,
          agreementDurationType: toLower(agreementDurationType),
          resellerLicenseAgreementType:
            toLower(resellerLicenseAgreementType) || null,
          percentageDiscount: percentageDiscount ? percentageDiscount : null,
          contractDurationInMonthsForEndCustomer: isNonEmptyNumber(
            contractDurationInMonthsForEndCustomer
          )
            ? contractDurationInMonthsForEndCustomer
            : null,
          agreementStakeholders: authorizationStakeholders,
          endCustomerEulaFiles:
            resaleAuthorization?.endCustomerEulaType !== EulaType.CUSTOM
              ? []
              : resaleAuthorization?.endCustomerEulaFiles,
          resellerLicenseAgreementFiles:
            resellerLicenseAgreementType !== EulaType.CUSTOM
              ? []
              : resaleAuthorization?.resellerLicenseAgreementFiles,
          installmentInfo: getFilteredInstallments(
            installmentInfo as unknown as Installments[]
          )?.map(item => ({ ...item, paymentDate: null })),
          agreementExpirationDate: null,
          ...mapObjectPropertyEmptyToNull({
            buyerAwsAccountId,
            awsAgreementId,
            contractDurationType,
            companyName,
          }),
          ...(crmOpportunityId ? { crmMetadata } : {}),
          ...mapResellersInfo({
            resellersInfo,
          }),
          awsProductId,
        }),
        products: getResellerProductDimensions({
          resaleAuthorizationState: {
            ...resaleAuthorizationState,
            discountType: discountType?.toUpperCase(),
            dimensions: resaleAuthorizationState?.products?.[0]?.dimensions,
          } as ResaleAuthorizationWithErrors,
          product,
        }),
      }
    }
    case 'AZURE': {
      const savePayload = getSubmitPayloadResaleAuthorization({
        cloud,
        resaleAuthorization:
          resaleAuthorizationState as ResaleAuthorizationWithErrors,
        product,
        userProfile: userProfile,
      })
      const {
        accept_by,
        offer_expiration_date,
        offer_start_date,
        mppo_name,
        ...remainingPayload
      } = savePayload
      return {
        ...remainingPayload,
        accept_by: null,
        offer_expiration_date: null,
        offer_start_date: null,
        mppo_name: `(Clone) ${mppo_name}`,
      }
    }
    case 'GCP': {
      return {}
    }
    case 'REDHAT': {
      return {}
    }
    default: {
      return {}
    }
  }
}

export const cloneResaleAuthorization =
  ({
    partnerId,
    productId,
    resaleAuthorizationState,
    crmOpportunityId,
    crmObjectLink,
    cloud,
    cloneId,
    handleNext,
  }: {
    partnerId: string
    productId: string
    resaleAuthorizationState: ResaleAuthorizationsResellerAgreements
    crmOpportunityId?: string
    crmObjectLink?: string
    cloud?: CloudMarketplace
    handleNext?: (id: string) => void
    cloneId?: string
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(
      startLoading(LoadingTypes.UPDATE_FLYOUT_RESELLER_AUTHORIZATION)
    )
    try {
      const cloudMarketplace = cloud || 'AWS'
      const product =
        getState().productsListing[cloudMarketplace].products?.rows.find(
          product => product.productId === productId
        ) || ({} as Product)

      const payload = transformResaleAuthForSave({
        product,
        resaleAuthorizationState,
        crmOpportunityId,
        crmObjectLink,
        userProfile: getState().userProfile.userProfile,
        cloud,
      })
      const response = await cloneAPIresaleAuthorization({
        partnerId,
        resaleAuthorization: payload,
        saveAsDraft: true,
        cloud,
        cloneId,
      })
      if (handleNext && response && response?.data) {
        const clonedResaleAuthorizationId =
          cloudMarketplace === 'AWS'
            ? camelize(response?.data).labraAwsResellerAgreementId
            : camelize(response?.data).mppoId
        await handleNext(clonedResaleAuthorizationId)
      }
      dispatch(
        updateAppAlert({
          message: cloneResaleAuthSuccess,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(
        stopLoading(LoadingTypes.UPDATE_FLYOUT_RESELLER_AUTHORIZATION)
      )
    }
  }

export const deactivateResaleAuthorization =
  ({
    partnerId,
    resellerAuthorizationId,
    awsAgreementId,
    handleNext,
    status,
  }: {
    partnerId: string
    resellerAuthorizationId?: string
    awsAgreementId: string
    handleNext?: () => void
    status?: ResellerAgreementStatus
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    await dispatch(
      startLoading(LoadingTypes.UPDATE_FLYOUT_RESELLER_AUTHORIZATION)
    )
    try {
      const dataToBeSent = {
        status: status || ResellerAgreementStatus.IN_PROGRESS,
        awsAgreementId,
      }
      const { data } = await patchResellerData(
        partnerId,
        resellerAuthorizationId as string,
        { ...dataToBeSent },
        false
      )
      if (handleNext && data) {
        await handleNext()
      }
      resellerAuthorizationId &&
        dispatch(
          getCurrentResaleAuthorization({
            partnerId,
            resaleAuthorizationId: resellerAuthorizationId,
            cloud: 'AWS',
          })
        )
      dispatch(
        updateAppAlert({
          message: deactivateResaleAuthSuccess,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      await dispatch(
        stopLoading(LoadingTypes.UPDATE_FLYOUT_RESELLER_AUTHORIZATION)
      )
    }
  }

const getSubmitPayloadResaleAuthorization = ({
  resaleAuthorization,
  cloud,
  product,
  userProfile,
  crmOpportunityId,
  crmObjectLink,
  saveAsDraft,
  labraNewUiRevamp,
}: {
  resaleAuthorization: ResaleAuthorizationWithErrors
  cloud?: CloudMarketplace
  product: Product
  userProfile: UserProfile
  crmOpportunityId?: string
  crmObjectLink?: string
  saveAsDraft?: boolean
  labraNewUiRevamp?: boolean
}) => {
  switch (cloud) {
    case 'AWS': {
      //TODO when we rewamp aws add logic here for payload
      const resaleAuthDataToBeSent = processSendDataPayload(
        resaleAuthorization,
        product,
        userProfile,
        crmOpportunityId,
        crmObjectLink,
        saveAsDraft,
        labraNewUiRevamp
      )
      return { ...snakeize(resaleAuthDataToBeSent) }
    }
    case 'AZURE': {
      const {
        plans,
        offerRecipients,
        metaData,
        azurePricingType,
        acceptBy,
        offerStartDate,
        agreementDescription,
        percentageDiscount,
        draft,
        hasBeenSent,
        errors,
        noOfTimesSaved,
        discountType,
        id,
        sellerId,
        status,
        labraOfferUrl,
        resellerDetails,
        offerExpirationDate,
        offerStakeholders,
        acceptanceLink,
        azureMppoId,
        createdAt,
        offerStatus,
        productName,
        customOfferStakeholders,
        statusLogs,
        offerApprovers,
        errorDetails,
        offerEndBuyers,
        ...remainingResaleAuthorization
      } = resaleAuthorization

      const payloadPlans = plans
        ?.filter(item => item?.labraPlanId)
        .map(({ originalPricing, pricing, ...remainingPlan }) => {
          const isItPerUser =
            pricing?.recurrentPrice?.recurrentPriceMode ===
            RecurrentPriceModeType.PERUSER

          const { userLimits, ...remainingRecurrentPrice } =
            pricing?.recurrentPrice

          const hasInstallmentSchedules =
            (pricing?.recurrentPrice?.prices?.[0]?.installments?.schedule
              ?.length ?? 0) > 0

          return {
            ...snakeize(remainingPlan),
            discount_type: azurePricingType,
            pricing: {
              recurrent_price: snakeize({
                ...remainingRecurrentPrice,
                ...(isItPerUser ? { userLimits } : {}),
                price_input_option: 'usd',
                ...(hasInstallmentSchedules
                  ? {
                      prices: [
                        {
                          ...remainingRecurrentPrice?.prices?.[0],
                          paymentOption: {
                            ...remainingRecurrentPrice?.prices?.[0]
                              ?.paymentOption,
                            type: 'flexible',
                          },
                          pricePerPaymentInUsd: undefined,
                        },
                      ],
                    }
                  : {}),
              }),
              custom_meters: {
                ...pricing?.customMeters,
                meters: processMeters(pricing?.customMeters?.meters || {}),
                price_input_option: 'usd',
              },
            },
          }
        })

      return {
        ...snakeize({
          ...remainingResaleAuthorization,
          privateOfferType: 'multipartyPromotionOriginator',
          offerPricingType: 'newCustomizedPlans',
          labraProductId: product?.productId,
          cloudProductId: product?.cloudMarketplaceProductId,
          preparedBy: userProfile?.email,
          offerRecipients: offerRecipients?.filter(item => item?.email),
          resellerDetails: resellerDetails?.filter(
            item => item?.id || item?.partnerName
          ),
          metaData: metaData
            ?.filter(item => item?.key || item?.value)
            .map(({ key, value }) => ({ key, value })),
          offerExpirationDate: offerExpirationDate || null,
          acceptBy: acceptBy || undefined,
          offerStartDate: offerStartDate || null,
          offerStakeholders: offerStakeholders?.concat(
            (customOfferStakeholders || [])?.map(({ email }) => ({
              email: email,
              firstName: '',
              lastName: '',
              title: '',
            }))
          ),
          offerEndBuyers: offerEndBuyers?.filter(
            item => !!(item?.email || item?.firstName || item?.lastName)
          ),
        }),
        plans: payloadPlans ? [...payloadPlans] : [],
      }
    }
    case 'GCP': {
      return {}
    }
    case 'REDHAT': {
      return {}
    }
    default: {
      return {}
    }
  }
}
export const submitResaleAuthorization =
  ({
    partnerId,
    productId,
    saveAsDraft,
    crmOpportunityId,
    crmObjectLink,
    submitCallBack,
    resaleAuthorization,
    labraNewUiRevamp = false,
    creatorData,
  }: {
    partnerId: string
    productId: string
    saveAsDraft?: boolean
    resaleAuthorization: ResaleAuthorizationWithErrors
    crmOpportunityId?: string
    crmObjectLink?: string
    submitCallBack?: (props: {
      id?: string
      isDraft?: boolean
      resaleAuthorization?: Record<string, unknown>
    }) => void
    labraNewUiRevamp?: boolean
    creatorData?: {
      creatorEmail?: string
      creatorName?: string
    }
  }) =>
  async (dispatch: AppDispatch, getState: () => RootState) => {
    if (saveAsDraft) {
      await dispatch(startLoading(LoadingTypes.DRAFT_SAVE_RESALE_AUTHORIZATION))
    } else {
      await dispatch(startLoading(LoadingTypes.SAVE_RESALE_AUTHORIZATION))
    }
    try {
      const cloudMarketplace = getState().productListingFilters.cloudMarketplace
      const product =
        getState().productsListing[cloudMarketplace].products?.rows.find(
          product => product.productId === productId
        ) || ({} as Product)

      const { userProfile } = getState().userProfile
      const { email, firstName } = userProfile
      const hasCreatorData = !isEmpty(firstName) && !isEmpty(email)
      const creatorDataToBeSent = creatorData
        ? snakeize({ creatorData: creatorData })
        : hasCreatorData
          ? {
              creator_data: { creator_name: firstName, creator_email: email },
            }
          : {}

      const sentPayload = getSubmitPayloadResaleAuthorization({
        cloud: cloudMarketplace,
        resaleAuthorization,
        product,
        userProfile: userProfile,
        crmOpportunityId,
        crmObjectLink,
        saveAsDraft,
        labraNewUiRevamp,
      })

      if (!resaleAuthorization?.id) {
        const response = await submitAPIresaleAuthorization({
          cloud: cloudMarketplace,
          resaleAuthorization: {
            ...sentPayload,
            ...(cloudMarketplace === 'AWS' ? creatorDataToBeSent : {}),
          },
          saveAsDraft,
          partnerId,
        })

        if (submitCallBack && response) {
          submitCallBack({
            id:
              cloudMarketplace === 'AWS'
                ? response?.data.labra_aws_reseller_agreement_id
                : response?.data?.mppo_id,
            isDraft: saveAsDraft,
          })
        }
      } else {
        await patchAPIresaleAuthorization({
          cloud: cloudMarketplace,
          resaleAuthorization: {
            ...sentPayload,
            ...(cloudMarketplace === 'AWS' ? creatorDataToBeSent : {}),
          },
          saveAsDraft,
          partnerId,
          resaleAuthorizationId: resaleAuthorization?.id,
        })

        if (submitCallBack && !saveAsDraft) {
          submitCallBack({
            id: resaleAuthorization?.id,
            isDraft: saveAsDraft,
            ...(saveAsDraft
              ? {
                  resaleAuthorization: resaleAuthorization as unknown as Record<
                    string,
                    unknown
                  >,
                }
              : {}),
          })
        }
      }

      dispatch(
        updateAppAlert({
          message: saveAsDraft
            ? resaleAuthorizationSaveSuccess
            : resaleAuthorizationCreationSuccess,
          messageType: 'SUCCESS',
          autoClose: true,
        })
      )
    } catch (error: any) {
      const e = error as AxiosError
      const errorResponse = e?.response as AxiosResponse<ErrorResponse>

      dispatch(
        updateAppAlert({
          message: getErrorMessages([RequestFailureMessage])(errorResponse),
          messageType: 'ERROR',
          autoClose: true,
        })
      )
      const globalState = getState()
      errorLogger({ globalState })(
        error as Error,
        errorResponse?.data?.track_id
      )
    } finally {
      if (saveAsDraft) {
        await dispatch(
          stopLoading(LoadingTypes.DRAFT_SAVE_RESALE_AUTHORIZATION)
        )
      } else {
        await dispatch(stopLoading(LoadingTypes.SAVE_RESALE_AUTHORIZATION))
      }
    }
  }

const cloneAPIresaleAuthorization = async ({
  resaleAuthorization,
  cloud,
  saveAsDraft,
  partnerId,
  cloneId,
}: {
  resaleAuthorization: Record<string, unknown>
  cloud?: CloudMarketplace
  partnerId: string
  saveAsDraft?: boolean
  cloneId?: string
}) => {
  switch (cloud) {
    case 'AWS': {
      return await postResaleAuthorization({
        partnerId,
        data: {
          ...resaleAuthorization,
        },
        saveAsDraft: true,
      })
    }
    case 'AZURE': {
      return await cloneMicrosoftResaleAuthorization({
        data: resaleAuthorization,
        saveAsDraft,
        partnerId,
        cloneId,
      })
    }
    case 'GCP': {
      return
    }
    case 'REDHAT': {
      return
    }
  }
}

const submitAPIresaleAuthorization = async ({
  resaleAuthorization,
  cloud,
  saveAsDraft,
  partnerId,
}: {
  resaleAuthorization: Record<string, unknown>
  cloud?: CloudMarketplace
  partnerId: string
  saveAsDraft?: boolean
}) => {
  switch (cloud) {
    case 'AWS': {
      return await postResaleAuthorization({
        partnerId,
        data: {
          ...resaleAuthorization,
        },
        saveAsDraft: saveAsDraft,
      })
    }
    case 'AZURE': {
      return await postMicrosoftResaleAuthorization({
        data: resaleAuthorization,
        saveAsDraft,
        partnerId,
      })
    }
    case 'GCP': {
      return
    }
    case 'REDHAT': {
      return
    }
  }
}

export const patchAPIresaleAuthorization = async ({
  resaleAuthorization,
  cloud,
  saveAsDraft,
  partnerId,
  resaleAuthorizationId,
}: {
  resaleAuthorization: Record<string, unknown>
  cloud?: CloudMarketplace
  partnerId: string
  saveAsDraft?: boolean
  resaleAuthorizationId: string
}) => {
  switch (cloud) {
    case 'AWS': {
      return await patchResellerData(
        partnerId,
        resaleAuthorizationId as string,
        { ...(resaleAuthorization as any) },
        saveAsDraft
      )
    }
    case 'AZURE': {
      return await patchMicrosoftResaleAuthorization({
        data: resaleAuthorization,
        saveAsDraft,
        partnerId,
        resaleAuthorizationId,
      })
    }
    case 'GCP': {
      return
    }
    case 'REDHAT': {
      return
    }
  }
}

export const processMeters = (
  meters: Record<string, any>
): Record<string, any> => {
  const snakeizedMeters: Record<string, any> = {}

  Object.keys(meters).forEach(meterKey => {
    snakeizedMeters[meterKey] = snakeize(meters[meterKey])
  })

  return snakeizedMeters
}
